import React, { StrictMode, ReactNode, ErrorInfo } from 'react';
import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './components/common/ScrollToTop.tsx';
import AppRoutes from './routes/AppRoutes.tsx';
import Navbar from './components/common/Navbar.tsx';
import Footer from './components/common/Footer.tsx';

// Error Boundary Component
class ErrorBoundary extends React.Component<{ children: ReactNode }, { hasError: boolean }> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): { hasError: boolean } {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught an error', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <h1 className="text-center text-red-500">Something went wrong. Please try again later.</h1>;
    }
    return this.props.children;
  }
}

const App = () => (
  <StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <div className="grid grid-rows-layout min-w-[390px] max-w-full h-screen" style={{ gridTemplateRows: 'auto 1fr auto' }}>
        <Navbar />
        <ErrorBoundary>
          <main className="flex-grow">
            <AppRoutes />
          </main>
        </ErrorBoundary>
        <Footer />
      </div>
    </BrowserRouter>
  </StrictMode>
);

export default App;
